import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { PurchasingService } from '../../services/purchasing.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { Tpl3plService } from '../../services/tpl3pl.service';
import { Tpl3plInboundResendPreviewDialogComponent } from '../tpl3pl-inbound-resend/tpl3pl-inbound-resend-preview-dialog.component';
import { formatPgsInboundDetail, uniquePgsInboundIds } from '../tpl3pl-inbound-display.util';
import { Location } from '@angular/common'
import * as _ from 'underscore';
import { PrintService } from 'app/services/print.service';

@Component({
	selector: 'app-open-purchase-orders',
	templateUrl: './open-purchase-orders.component.html',
	styleUrls: ['./open-purchase-orders.component.scss']
})
export class OpenPurchaseOrdersComponent implements OnInit, OnChanges {
	static readonly OPEN_PO_FILTER_KEY = 'openPurchaseOrdersFilters';

	@Input() config: any = [];
	@Input() item: any = false;
	@Input() vendor: any = false;
	// True when embedded inside another view (e.g. the vendor tab) rather than
	// shown as a standalone dashboard card. Suppresses the floating card icon.
	@Input() embedded: boolean = false;
	@Output() update_item = new EventEmitter < any > ();
	@Output() orderloaded = new EventEmitter < any > ();
	@Output() po_data = new EventEmitter < any > ();
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	purchaseorders: any = [];
	allpurchaseorders: any = [];
	private readonly baseHeaderColumns: string[] = [
		'actions',
		'orderno',
		'status_id',
		'suppname',
		'comments',
		'orddate',
		'requisitionno',
		'ordervalue',
		'orderpendingvalue',
		'ordereditems',
		'deliverydate',
		'initiator',
	];
	headercolumns: string[] = [...this.baseHeaderColumns];

	statuses: any = [];
	openOrderData: any = [];
	baselink = '';
	grnlink = '';
	explink = '';
	reclink = '';
	color = '';
	podetails: any = [];
	vendorSearch = new FormControl('');
	searchInputItems = new UntypedFormControl('');
	status = new FormControl('');
	searchBySize = false;
	includeSizes = false;
	searching = false
	loading = false;
	updatingStatusOrderNo: string | null = null;
	search: any = false;
	itemsearch = false;
	itemsearchsubscription: any = false;
	itemsearchresults: any = [];
	purchaseordersFiltered: any = [];
	tableData: any = [];
	orderwarning: any = false;
	tpl3plPgsEnabled = false;
	inboundStatusLoading = false;
	inboundSending = false;
	inboundStatus: any = null;
	inboundLastMessage = '';
	showFilters = true;

	private static readonly THEME_PALETTE: Record<string, { light: [number, number, number]; base: [number, number, number]; dark: [number, number, number] }> = {
		purple:  { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		primary: { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		blue:    { light: [144, 202, 249], base: [ 33, 150, 243], dark: [ 25, 118, 210] },
		info:    { light: [128, 222, 234], base: [  0, 188, 212], dark: [  0,  96, 100] },
		green:   { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		success: { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		orange:  { light: [255, 204, 128], base: [255, 152,   0], dark: [230,  81,   0] },
		warning: { light: [255, 224, 130], base: [255, 193,   7], dark: [255, 143,   0] },
		red:     { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		danger:  { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		rose:    { light: [244, 143, 177], base: [233,  30,  99], dark: [136,  14,  79] },
	};

	get palette() {
		return OpenPurchaseOrdersComponent.THEME_PALETTE[this.color] || OpenPurchaseOrdersComponent.THEME_PALETTE['blue'];
	}

	get themeVars(): { [key: string]: string } {
		const p = this.palette;
		const rgb  = (c: number[]) => `rgb(${c[0]},${c[1]},${c[2]})`;
		const rgba = (c: number[], a: number) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
		return {
			'--opo-accent':        rgb(p.base),
			'--opo-accent-dark':   rgb(p.dark),
			'--opo-accent-light':  rgb(p.light),
			'--opo-accent-tint':   rgba(p.base, 0.07),
			'--opo-accent-tint-2': rgba(p.base, 0.14),
			'--opo-accent-border': rgba(p.base, 0.20),
			'--opo-accent-bg':     rgba(p.light, 0.16),
		};
	}

	statCount = 0;
	statTotalValue = 0;
	statAvgValue = 0;

	private updateStats(): void {
		const data = Array.isArray(this.openOrderData) ? this.openOrderData : [];
		this.statCount = data.length;
		let total = 0;
		for (let i = 0; i < data.length; i++) {
			total += (parseFloat(data[i]?.ordervalue) || 0);
		}
		this.statTotalValue = total;
		this.statAvgValue = this.statCount ? total / this.statCount : 0;
	}

	constructor(
		private printService: PrintService,
		private route: ActivatedRoute,
		private purchasingService: PurchasingService,
		private globalsService: GlobalsService,
		public globalSearchService: GlobalSearchService,
		public location: Location,
		private modalService: NgbModal,
		private cdr: ChangeDetectorRef,
		private tpl3plService: Tpl3plService,
		private dialog: MatDialog,
	) {
		this.color = 'orange';
		this.config = this.globalsService.getApiConfig();
		this.applyStoredOrDefaultFilters();
	}

	private hasVendorContext(): boolean {
		return !!(this.vendor && this.vendor.supplierid);
	}

	private applyStoredOrDefaultFilters(): void {
		const restored = this.getStoredFilters();
		if (restored) {
			if (restored.status != null && restored.status !== '') {
				this.status.setValue(restored.status, { emitEvent: false });
			} else {
				this.status.setValue('OPEN', { emitEvent: false });
			}
			if (restored.keywords != null) {
				this.vendorSearch.setValue(restored.keywords, { emitEvent: false });
			}
			if (restored.searchInputItems != null) {
				this.searchInputItems.setValue(restored.searchInputItems, { emitEvent: false });
			}
		} else {
			this.status.setValue('OPEN', { emitEvent: false });
		}
	}

	ngOnInit(): void {
		this.baselink = this.config.apiServer.poLink;
		this.explink = '?route=apir/documents/popicking/excel&key=' + this.config.apiCredentials.clientId + '&orderno=';
		this.grnlink = '?route=apir/documents/grn&key=' +this.config.apiCredentials.clientId + '&grnbatch=';
		this.reclink = this.config.apiServer.recLink;

		if (this.config.env.package == 'tires') {
			this.includeSizes = true;
		}

		if (!this.hasVendorContext()) {
			this.fetchPurchaseOrders(true, this.item, false, this.includeSizes);
		}

		this.tpl3plService.getConfig().subscribe({
			next: (cfg: any) => {
				this.tpl3plPgsEnabled = this.isTpl3plPgsConfigured(cfg);
				this.refreshHeaderColumns();
			},
			error: () => {
				this.tpl3plPgsEnabled = false;
				this.refreshHeaderColumns();
			}
		});
	}

	private isTpl3plPgsConfigured(cfg: any): boolean {
		if (!cfg?.enabled || cfg?.integration_type !== 'PGS') {
			return false;
		}
		const pgs = cfg?.config_json?.pgs;
		return !!(pgs?.baseUrl && pgs?.userId && pgs?.passwd);
	}

	private refreshHeaderColumns(): void {
		const cols = [...this.baseHeaderColumns];
		if (this.tpl3plPgsEnabled) {
			const statusIdx = cols.indexOf('status_id');
			if (statusIdx >= 0 && !cols.includes('tpl3pl_inbound')) {
				cols.splice(statusIdx + 1, 0, 'tpl3pl_inbound');
			}
		}
		this.headercolumns = cols;
	}

	getTpl3plInboundStatus(tran: any): { state: 'sent' | 'receiving' | 'received' | 'error' | 'not_sent'; label: string; detail: string } {
		const poStatusId = Number(tran?.status_id);
		if (poStatusId === 80) {
			return { state: 'received', label: 'Received', detail: 'PO fully received in ERP' };
		}
		if (poStatusId === 60) {
			return { state: 'receiving', label: 'Receiving', detail: 'PO receiving in progress' };
		}
		if (poStatusId === 30) {
			return { state: 'receiving', label: 'At warehouse', detail: 'Goods at warehouse' };
		}

		const raw = tran?.tpl3pl_inbound_response;
		let data: any = null;
		if (raw != null && raw !== '') {
			data = typeof raw === 'string'
				? (() => { try { return JSON.parse(raw); } catch { return null; } })()
				: raw;
		}
		const ids: string[] = [];
		const hardErrors: string[] = [];
		if (data && typeof data === 'object') {
			const inner = data.Data ?? data.data ?? data;
			const details = inner?.DetailsLoaded ?? inner?.detailsLoaded ?? [];
			if (Array.isArray(details)) {
				for (const d of details) {
					const id = d?.pgsInboundID ?? d?.pgsinboundid;
					const msg = (d?.msg ?? '').toString().trim();
					if (id != null && id !== '') {
						ids.push(String(id));
					} else if (msg) {
						const dupId = this.extractDuplicateInboundId(msg);
						if (dupId) {
							ids.push(dupId);
						} else if (!this.isBenignInboundMessage(msg)) {
							hardErrors.push(msg);
						}
					}
				}
			}
		}
		const uniqueIds = uniquePgsInboundIds(ids);
		if (uniqueIds.length) {
			return { state: 'sent', label: 'Sent', detail: formatPgsInboundDetail(uniqueIds) };
		}
		if (poStatusId >= 20) {
			return { state: 'sent', label: 'Sent', detail: 'Marked sent to 3PL' };
		}
		if (hardErrors.length) {
			return { state: 'error', label: 'Error', detail: hardErrors.join('; ') };
		}
		if (data && this.hasOnlyBenignInboundMessages(data)) {
			return { state: 'sent', label: 'Sent', detail: 'Inbound exists at PGS (pending receipt)' };
		}
		return { state: 'not_sent', label: 'Not sent', detail: 'Inbound not yet sent to PGS' };
	}

	private isBenignInboundMessage(msg: string): boolean {
		if (/duplicate inbound\s*\(\d+\)/i.test(msg)) { return true; }
		if (/can.t be updated because of current status:\s*pending/i.test(msg)) { return true; }
		return false;
	}

	private extractDuplicateInboundId(msg: string): string | null {
		const m = msg.match(/duplicate inbound\s*\((\d+)\)/i);
		return m ? m[1] : null;
	}

	private hasOnlyBenignInboundMessages(data: any): boolean {
		const inner = data.Data ?? data.data ?? data;
		const details = inner?.DetailsLoaded ?? inner?.detailsLoaded ?? [];
		if (!Array.isArray(details) || !details.length) { return false; }
		let hasMsg = false;
		for (const d of details) {
			const id = d?.pgsInboundID ?? d?.pgsinboundid;
			if (id != null && id !== '') { return false; }
			const msg = (d?.msg ?? '').toString().trim();
			if (!msg) { continue; }
			hasMsg = true;
			if (!this.isBenignInboundMessage(msg)) { return false; }
		}
		return hasMsg;
	}

	getInboundPanelDisplay(): { state: string; label: string; detail: string } {
		if (this.inboundStatus?.display_state) {
			return {
				state: this.inboundStatus.display_state,
				label: this.inboundStatus.display_label || this.inboundStatus.display_state,
				detail: this.inboundStatus.display_detail || '',
			};
		}
		if (this.podetails?.poheader) {
			return this.getTpl3plInboundStatus(this.podetails.poheader);
		}
		return { state: 'not_sent', label: 'Not sent', detail: '' };
	}

	private applySearchResults(results: any): void {
		const pos = Array.isArray(results?.pos) ? results.pos : [];
		this.allpurchaseorders = results && typeof results === 'object' ? { ...results, pos } : { pos };
		this.po_data.emit(results);
		this.statuses = Array.isArray(results?.statuses) ? results.statuses : [];
		this.openOrderData = pos;
		this.updateStats();
		this.setTableData(this.openOrderData);
		this.storeFilters();
	}

	private fetchPurchaseOrders(showLoading: boolean, item: any, vendor: any, size: boolean, onSuccess?: () => void): void {
		if (showLoading) {
			this.loading = true;
		}
		const search: any = {
			status: this.status.value,
			keywords: this.vendorSearch.value,
			item: item ?? this.item,
			vendor: vendor !== undefined ? vendor : this.vendor
		};
		if (size) {
			search.size = true;
		}
		this.purchasingService.searchPurchaseOrders(search).subscribe({
			next: (results: any) => {
				this.applySearchResults(results);
				if (showLoading) {
					this.loading = false;
				}
				onSuccess?.();
			},
			error: () => {
				if (showLoading) {
					this.loading = false;
				}
			}
		});
	}

	loadData(): void {
		const vendor = this.hasVendorContext() ? this.vendor : false;
		this.fetchPurchaseOrders(true, this.item, vendor, this.includeSizes);
	}

	getStoredFilters(): { status: string; keywords: string; searchInputItems: string } | null {
		try {
			const raw = sessionStorage.getItem(OpenPurchaseOrdersComponent.OPEN_PO_FILTER_KEY);
			return raw ? JSON.parse(raw) : null;
		} catch {
			return null;
		}
	}

	storeFilters(): void {
		try {
			sessionStorage.setItem(OpenPurchaseOrdersComponent.OPEN_PO_FILTER_KEY, JSON.stringify({
				status: this.status.value,
				keywords: this.vendorSearch.value,
				searchInputItems: this.searchInputItems.value
			}));
		} catch {}
	}

	getStatus(id: any) {
		return this.statuses.filter((st) => {
			return parseFloat(st.status_id) == parseFloat(id)
		})[0];
	}

	loadOrder(orderno: any) {
		this.purchasingService.loadPurchaseOrder(orderno).subscribe((result: any) => {
			this.orderloaded.emit(result);
		});
	}

	searchItems() {
		this.loading = true;
		const search: any = {
			status: this.status.value,
			keywords: false,
			item: this.searchInputItems.value,
			vendor: this.vendor,
			size: this.searchBySize
		};
		this.purchasingService.searchPurchaseOrders(search).subscribe({
			next: (results: any) => {
				this.applySearchResults(results);
				this.loading = false;
			},
			error: () => {
				this.loading = false;
			}
		});
	}

	searchOrders(silent = false) {
		if (!silent) {
			this.loading = true;
		}
		const search = {
			status: this.status.value,
			keywords: this.vendorSearch.value,
			item: this.item,
			vendor: this.vendor
		};
		const preserved = silent ? {
			status: this.status.value,
			keywords: this.vendorSearch.value,
			searchInputItems: this.searchInputItems.value
		} : null;

		this.purchasingService.searchPurchaseOrders(search).subscribe({
			next: (results: any) => {
				this.applySearchResults(results);
				if (preserved) {
					this.status.setValue(preserved.status, { emitEvent: false });
					this.vendorSearch.setValue(preserved.keywords, { emitEvent: false });
					this.searchInputItems.setValue(preserved.searchInputItems, { emitEvent: false });
				}
				this.onInput();
				if (!silent) {
					this.loading = false;
				}
				this.updatingStatusOrderNo = null;
				this.cdr.detectChanges();
			},
			error: () => {
				if (!silent) {
					this.loading = false;
				}
				this.updatingStatusOrderNo = null;
				this.cdr.detectChanges();
			}
		});
	}

	updateStatus(event: any, trans: any) {
		const status_details = this.getStatus(event.value);
		const index = this.allpurchaseorders.pos.indexOf(trans);
		this.allpurchaseorders.pos[index].editing = false;
		this.allpurchaseorders.pos[index].status_id = status_details.status_id;
		this.allpurchaseorders.pos[index].statusname = status_details.name;

		this.updatingStatusOrderNo = trans.orderno;
		this.cdr.detectChanges();

		this.purchasingService.updateStatus(this.allpurchaseorders.pos[index]).subscribe({
			next: () => {
				this.searchOrders(true);
			},
			error: () => {
				this.updatingStatusOrderNo = null;
				this.cdr.detectChanges();
				this.searchOrders(true);
			}
		});
	}

	exportExcel() {
		this.globalSearchService.exportJsonToExcel(this.allpurchaseorders.pos, 'OpenPurchaseOrders');
	}



	toggleStatusChange(trans: any) {
		const index = this.allpurchaseorders.pos.indexOf(trans);

		if(trans.statusname.toLowerCase() === 'dropship'){
			let msg = '*** DROPSHIP ORDER IN PROGRESS ***';
			if(this.allpurchaseorders.pos[index].editing){
				msg = null;
			}
			this.showWarning(trans, msg);
		}

		if (this.allpurchaseorders.pos[index].editing) {
			this.allpurchaseorders.pos[index].editing = false;
		} else {
			this.allpurchaseorders.pos[index].editing = true;
		}
	}

	showWarning(trans, msg){
		this.orderwarning = msg == null ? false : { orderno: trans.orderno, msg: msg }
	}

	onInput() {
		//tood make this ajax call to search for items on orders as well
		this.purchaseorders = this.openOrderData
		const search = this.vendorSearch.value;
		this.searching = true;
		this.filterByStatus();
		this.purchaseorders = this.globalSearchService.filterItem(this.purchaseorders, search, 'orderno,suppname,supplierno,deliverydate,itemcode,itemdescription,requisitionno,initiator,comments');
		this.setTableData(this.purchaseorders)
		this.searching = false;
	}

	announceSortChange(event: any) {

	}

	viewOrder(orderno: any, content: any) {
		this.purchasingService.getPurchaseOrder(orderno).subscribe((order: any) => {
			this.podetails = order;
			this.inboundStatus = null;
			this.inboundLastMessage = '';
			if (this.tpl3plPgsEnabled && orderno) {
				this.loadInboundStatus(String(orderno));
			}
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}

	loadInboundStatus(orderno: string): void {
		this.inboundStatusLoading = true;
		this.tpl3plService.getInboundPoStatus(orderno).subscribe({
			next: (res) => {
				this.inboundStatusLoading = false;
				if (res.success) {
					this.inboundStatus = res.data || null;
					const display = this.getInboundPanelDisplay();
					const latest = res.data?.latest_attempt;
					const latestMsg = latest?.message || '';
					if (display.state === 'error' || (latest?.status === 'error' && display.state !== 'sent' && display.state !== 'receiving' && display.state !== 'received')) {
						this.inboundLastMessage = latestMsg;
					} else if (latest?.status === 'error' && latestMsg) {
						this.inboundLastMessage = 'Last resend note: ' + latestMsg;
					} else {
						this.inboundLastMessage = display.detail || latestMsg;
					}
				}
			},
			error: () => {
				this.inboundStatusLoading = false;
			}
		});
	}

	sendInboundToPgs(orderno: string, forceResend = false): void {
		if (!this.tpl3plPgsEnabled || this.inboundSending || !orderno) { return; }
		this.inboundSending = true;
		this.tpl3plService.sendInboundPo(String(orderno), forceResend).subscribe({
			next: (res) => {
				this.inboundSending = false;
				const msg = res.success
					? (res.skipped ? (res.message || 'Inbound already sent') : (res.message || 'Inbound sent to PGS'))
					: (res.message || 'Inbound send failed');
				this.globalSearchService.showNotification(msg, res.success && !res.skipped ? 'success' : 'warning', 'bottom', 'right');
				this.loadInboundStatus(String(orderno));
			},
			error: (err) => {
				this.inboundSending = false;
				this.globalSearchService.showNotification(err?.error?.message || 'Inbound send failed', 'danger', 'bottom', 'right');
			}
		});
	}

	openInboundPreview(orderno: string, forceResend = false): void {
		if (!orderno) { return; }
		const ref = this.dialog.open(Tpl3plInboundResendPreviewDialogComponent, {
			width: '720px',
			maxWidth: '96vw',
			maxHeight: '90vh',
			data: {
				orderNo: String(orderno),
				forceResend,
				onSent: () => this.loadInboundStatus(String(orderno)),
			}
		});
		ref.afterClosed().subscribe((result) => {
			if (result?.success) {
				this.loadInboundStatus(String(orderno));
			}
		});
	}

	get inboundAlreadySent(): boolean {
		return !!this.inboundStatus?.sent;
	}


	back(): void {
		this.location.back()
	}

	setTableData(data: any) {
		const dataArr = Array.isArray(data) ? data : [];
		if (!Array.isArray(this.tableData) || !this.tableData.length) {
			this.tableData = dataArr;
		}
		this.purchaseorders = new MatTableDataSource(dataArr);
		this.purchaseorders.sort = this.sort;
		setTimeout(()=>{
			this.purchaseorders.paginator = this.paginator;
		},1000)
		this.filterByStatus();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!changes) {
			return;
		}
		if (this.config.env.package == 'tires') {
			this.includeSizes = true;
		}

		if (changes['vendor']) {
			const isFirstChange = changes['vendor'].firstChange;

			if (this.hasVendorContext()) {
				const vendorDisplay = this.vendor.suppname || this.vendor.supplierid || '';
				if (vendorDisplay) {
					this.vendorSearch.setValue(vendorDisplay, { emitEvent: false });
				}
				this.fetchPurchaseOrders(true, this.item, this.vendor, this.includeSizes);
				return;
			}

			if (this.vendor === false || this.vendor === null || this.vendor === undefined) {
				if (isFirstChange) {
					return;
				}
				this.fetchPurchaseOrders(true, this.item, false, this.includeSizes);
				return;
			}

			this.openOrderData = [];
			this.allpurchaseorders = { pos: [] };
			this.setTableData([]);
			return;
		}

		if (changes['item']) {
			const vendor = this.hasVendorContext() ? this.vendor : false;
			this.fetchPurchaseOrders(true, this.item, vendor, this.includeSizes);
		}
	}

	filterByStatus() {
		const key = this.status.value;
		console.log(key);

		if (key && key !== 'OPEN') {
			this.purchaseorders = this.openOrderData.filter((item: any) => item.status_id == key);
		}
	}

	getTotalQuantity(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + parseFloat(item.quantityord), 0);
	}

	getTotalValue(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + (parseFloat(item.unitprice) * parseFloat(item.quantityord)), 0);
	}

	async copyToClipboard(text: string): Promise < void > {
		try {
			await navigator.clipboard.writeText(text);
		} catch (err) {}
	}


	onStatusSelection() {
		this.searchOrders();
	}

	exportXls() {
		const date = new Date();
		const today = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
		const encoded: string = this.globalSearchService.base64encode(this.getHtmlTable());
		const data = {
			content: encoded,
			filename: 'openPurchaseOrders',
			title: 'Open Purchase Orders',
			subtitle: `All open purchase orders as of ${today}`
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	exportPdf() {
		const date = new Date();
		const today = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
		const encoded: string = this.globalSearchService.base64encode(this.getHtmlTable());
		const data = {
			content: encoded,
			filename: 'openPurchaseOrders',
			title: 'Open Purchase Orders',
			subtitle: `All open purchase orders as of ${today}`
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	getHtmlTable() {
		const style = {
			'1': 'style="text-align:left"',
			'2': 'style="text-align:center"',
			'3': 'style="text-align:right"',
		}

		const printjson = [];
		(this.allpurchaseorders.pos).forEach(o => {
			const row = {
				'1Order #': o.orderno,
				'2Requisition #': o.requisitionno,
				'1Status': o.statusname,
				'1Order Date': o.orddate,
				'1Wanted Date': o.deliverydate,
				'1Supplier #': o.supplierno,
				'1Supplier': o.suppname,
				'2#Ordered': o.ordered,
				'2#Recieved': o.rec,
				'2#Pending': o.pendingitems,
				'3Order Value': this.financial(Number(o.ordervalue)),
				'3Pending Value': this.financial(Number(o.orderpendingvalue)),
				'3Initiator': o.initiator,
			}
			printjson.push(row);
		});

		let html = '<table><thead><tr>';
		Object.keys(printjson[0]).forEach((k) => {
			html += `<th>${k.substring(1)}</th>`;
		})

		html += '</tr></thead><tbody>';
		printjson.forEach(row => {
			html += '<tr>'
			Object.keys(row).forEach((k) => {
				html += `<td ${style[k.substring(0,1)]}>${row[k]}</td>`
			})
			html += '</tr>'
		});
		html += '</tbody></table>'
		return html;
	}

	getLineTotal(item: any): number {
		const price = parseFloat(item.unitprice ?? '0') || 0;
		const qty = parseFloat(item.quantityord ?? '0') || 0;
		const fet = (this.config.env.package === 'tires') ? (parseFloat(item.fetcharge ?? '0') || 0) : 0;
		return this.financial((price + fet) * qty);
	}

	getTotalFet(): number {
		const total = this.podetails.polines.reduce((sum, item) => {
			const fet = parseFloat(item.fetcharge ?? '0') || 0;
			const qty = parseFloat(item.quantityord ?? '0') || 0;
			return sum + fet * qty;
		}, 0);
		return this.financial(total);
	}

	getTotalValueWithFet(): number {
		const total = this.podetails.polines.reduce((sum, item) => {
			const price = parseFloat(item.unitprice ?? '0') || 0;
			const qty = parseFloat(item.quantityord ?? '0') || 0;
			const fet = (this.config.env.package === 'tires') ? (parseFloat(item.fetcharge ?? '0') || 0) : 0;

			// Optional: Debug log
			if (qty > 100) {
				console.warn('Unusual quantity detected:', { item, price, qty, fet });
			}

			return sum + (price + fet) * qty;
		}, 0);
		return this.financial(total);
	}

	financial(num: number): number {
		if (!num) {
			num = 0.00;
		}
		const rounded = Math.round((num + Number.EPSILON) * 100) / 100;
		return parseFloat(rounded.toFixed(2));
	}


	searchSize(){
		const search = this.searchInputItems.value;
		const ordersFiltered  = this.tableData.filter((ord) => {
			return ord.sizes.includes(search);
		});
		this.setTableData(ordersFiltered);
	}

	switchToSize(){
		this.searchBySize = !this.searchBySize;
	}
}
